import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Cons from '../../isomorphic/cons';
import mobx from 'mobx';
import form from './agent-profile-form-component';
import Notifications from '../utils/notification-helper';
import moment from 'moment';
import LastUpdatedBy from '../components/last-updated-by-component';
import SkyCKEditor from '../shared/skyckeditor';
import PermissionHelper from '../components/permission-wrapper';
import Breadcrumbs from '../components/breadcrumbs-component';

const DEFAULT_AGENT_PREFERENCES = `<b>The Agent:</b>
        <p>Preferred contact:<br>
        <b style="color: red;">PRICING</b>
        <ul>
        <li>Full Service TC File: $</li>
        <li>TC Light File: $</li>
        <li>Vacant Land File: $</li>
        <li>Double Ended File: $</li>
        <li>Double Ended Vacant Land File: $</li>
        </ul>
        <br>
        Temperament:<br>
        Extra(s):</p>
        <br>
        <b>Signing Platform:</b>
        <p>Additional CC (if applicable):</p>
        <br>
        <b>Other Platforms (if any):</b>
        <p>Who prepares:<br>
        Does agent review prior to sending:<br>
        Preferred signing order:<br>
        Corrections (if applicable):<br>
        One off docs & location:</p>
        <br/>
        <b>Initiation Process:</b>
        <p>Intro emails:<br>
        Additional CC (if applicable):<br>
        Transaction Timeline:<br>
        If corrections are needed do the following:</p>
        <br/>
        <b>Incoming Docs/Doc Setup:</b>
        <p>Agent permission:<br>
        Signing position:<br>
        Extra(s):</p>
        <br/>
        <b>During Transaction:</b>
        <p>Calendars:<br>
        Other:</p>
        <br/>
        <b>Commission Instruction:</b>
        <p>Who signs:<br>
        Extra(s):</p>`;

@inject('appStore')
@observer
export default class AgentProfileForm extends Component {
    constructor(props) {
        super(props);
        this.form = form(props.appStore);
    }

    onSave() {
        document.getElementById('btnSavePreferredEmail').disabled = true;
        this.form.validate({ showErrors: true }).then((form) => {
            if (form.isValid) {
                // TODO: Extract logic into another module/helper
                const formattedFields = {};
                _.each(this.form.values(), (value, key) => {
                    if (form.fields.get(key).$extra === 'date') {
                        if (!moment.isMoment(value)) {
                            value = moment(value);
                        }

                        formattedFields[key] = value.isValid() ? value.format() : null;
                    } else {
                        formattedFields[key] = value;
                    }
                });
                // these could be better. assigning after the binding...
                formattedFields['agentPreferences'] = CKEDITOR.instances['agentPreferences-editor'].getData();
                if (this.props.appStore.permissionStore.can('brokerageprofile.edit')) {
                    formattedFields['brokeragePreferences'] = CKEDITOR.instances[
                        'brokeragePreferences-editor'
                    ].getData();
                }                
                this.props.appStore.agentProfileStore.updateSelectedAgentProfile(formattedFields);
            } else {
                document.getElementById('btnSavePreferredEmail').disabled = false;
                const errorMessages = _.filter(form.errors(), (value, key) => {
                    return key !== 'agents' && !_.isUndefined(value);
                });
                Notifications.ToastError(errorMessages);
            }
        });
    }

    updateFieldsFromStore(props) {
        _.each(mobx.toJS(props.appStore.agentProfileStore.selectedAgentProfileViewModel), (value, key) => {
            if (this.form.has(key)) {
                if (key === 'agentPreferences' && !value) {
                    this.form.$(key).set(DEFAULT_AGENT_PREFERENCES);
                } else {
                    this.form.$(key).set(value);
                }
            }
        });
    }

    handleRefferalTypeChange = (field) => (e, key, val) => {
        field.set('value', val);
    };

    componentDidMount() {
        this.form.clear();
        this.updateFieldsFromStore(this.props);

        this.form.$('referralType').observe((form, field, change) => {
            this.form.$(`salesRepresentative`).value = '';
        });
    }

    render() {
        const users = _.chain(this.props.appStore.coordinatorStore.coordinators.values()).value(),
            commissionEligibleRoles = [Cons.roles.sales],
            commissionEligibleUsers = users.filter((user) => commissionEligibleRoles.includes(user.roles[0].name)),
            transactionCoordinatorUsers = users.filter((user) => user.roles[0].name === Cons.roles.tc),
            agent = this.props.appStore.agentStore.combinedAgents.find(
                (agent) => agent.agentContactId === this.props.appStore.viewStore.selectedAgentId
            ),
            breadcrumbItems = [
                {
                    label: appStore.viewStore.previousPage.label,
                    href: `#/${appStore.viewStore.previousPage.page}`,
                },
                { label: agent.name },
            ];
        return (
            <form
                key={`agent-profile-${this.props.appStore.agentProfileStore.selectedAgentProfileViewModel.agentContactId}`}
            >
                <div className="col-xs-12 col-sm-12">
                    <Breadcrumbs items={breadcrumbItems} />
                </div>
                <div className="col-xs-12 no-padding">
                    <div className="col-xs-6">
                        <div className="form-group">
                            <label htmlFor={this.form.$(`preferredEmail`).id}>
                                {this.form.$(`preferredEmail`).label}
                            </label>
                            <input className="form-control" {...this.form.$(`preferredEmail`).bind()} />
                            <p className="form-error">{this.form.$(`preferredEmail`).error}</p>
                        </div>
                    </div>
                    <div className="col-xs-6"></div>
                </div>
                <div className="col-xs-6">
                    <div className="form-group">
                        <label htmlFor={this.form.$(`referralType`).id}>{this.form.$(`referralType`).label}</label>
                        <select className="form-control" {...this.form.$(`referralType`).bind()}>
                            <option value="">Select a Type</option>
                            {_.map(Cons.refferalTypes, (value, key) => {
                                return (
                                    <option key={key} value={value}>
                                        {key}
                                    </option>
                                );
                            })}
                        </select>
                        <p className="form-error">{this.form.$(`referralType`).error}</p>
                    </div>
                </div>

                {/*Sales Representative*/}
                <div className="col-xs-6">
                    <div className="form-group">
                        <label htmlFor={this.form.$(`salesRepresentative`).id}>
                            {this.form.$(`salesRepresentative`).label}
                        </label>
                        <select
                            className="form-control"
                            {...this.form.$(`salesRepresentative`).bind()}
                            disabled={
                                this.form.$(`referralType`).value === Cons.refferalTypes['Transaction Coordinator'] ||
                                this.form.$(`referralType`).value === Cons.refferalTypes['Sales Representative']
                                    ? ''
                                    : this.form.$(`referralType`).disable
                                    ? 'disabled'
                                    : 'disabled'
                            }
                        >
                            <option value="">Select a Type</option>
                            {this.form.$(`referralType`).value === Cons.refferalTypes[`Transaction Coordinator`]
                                ? _.map(transactionCoordinatorUsers, (user) => {
                                      return (
                                          <option key={user.coordinatorId} value={user.coordinatorId}>
                                              {user.name}
                                          </option>
                                      );
                                  })
                                : _.map(commissionEligibleUsers, (user) => {
                                      return (
                                          <option key={user.coordinatorId} value={user.coordinatorId}>
                                              {user.name}
                                          </option>
                                      );
                                  })}
                        </select>
                        <p className="form-error">{this.form.$(`salesRepresentative`).error}</p>
                    </div>
                </div>
                {/* Agent and Brokerage Preferences */}
                <div className="col-xs-12">
                    <div className="form-group">
                        <label htmlFor={this.form.$(`agentPreferences`).id}>
                            {this.form.$(`agentPreferences`).label}
                        </label>
                        {React.createElement(SkyCKEditor, {
                            container: 'editable',
                            readOnly: this.form.$(`agentPreferences`).disabled,
                            data: this.form.$(`agentPreferences`).value || '',
                            editorId: 'agentPreferences-editor',
                            removePlugins: 'link',
                        })}
                        <p className="form-error">{this.form.$(`agentPreferences`).error}</p>
                    </div>
                </div>
                <div className="col-xs-12">
                    <div className="form-group">
                        <label htmlFor={this.form.$(`brokeragePreferences`).id}>
                            {this.form.$(`brokeragePreferences`).label}
                        </label>
                        {React.createElement(SkyCKEditor, {
                            container: 'editable',
                            readOnly: this.form.$(`brokeragePreferences`).disabled,
                            data: this.form.$(`brokeragePreferences`).value || '',
                            editorId: 'brokeragePreferences-editor',
                            removePlugins: 'link',
                        })}
                        <p className="form-error">{this.form.$(`brokeragePreferences`).error}</p>
                    </div>
                </div>
                {/*Form Actions*/}
                <div className="col-xs-12 form-actions">
                    <PermissionHelper permission="agentprofile.edit" behavior={{ disabled: true }}>
                        <button id="btnSavePreferredEmail" type="button" className="btn btn-primary pull-right" onClick={this.onSave.bind(this)}>
                            Save
                        </button>
                    </PermissionHelper>

                    <button
                        type="button"
                        className="btn btn-default pull-right"
                        onClick={() => {
                            // this.props.appStore.analytics.track("Agent Detail Canceled", {})
                            this.props.appStore.viewStore.openPreviousPage();
                        }}
                    >
                        Cancel
                    </button>
                    <p className="form-error">{this.form.error}</p>
                </div>

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <LastUpdatedBy
                        model={this.props.appStore.agentProfileStore.selectedAgentProfile}
                        coordinators={this.props.appStore.coordinatorStore.coordinators}
                    />
                </div>
            </form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/agent-profile/agent-profile-form-view.js